import { Component, Input, OnInit } from '@angular/core';
import { LayoutService } from '@app/layout/layout.service';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { ADOCRecord } from './adoc-report';
import { RecordPageComponent } from '../../record-page.component';
import { CompareResultComponent } from './compare-result/compare-result.component';

@Component({
  selector: 'app-record-change-log',
  templateUrl: './record-change-log.component.html',
  styleUrls: ['./record-change-log.component.less'],
})
export class RecordChangeLogComponent implements OnInit {
  @Input() DocEntry: string;
  @Input() DocType: string;
  @Input() moduleId: number;

  adocRows: ADOCRecord[];
  selectedRows: any[] = [];
  isLoading = false;

  isSelected(row: any): boolean {
    return this.selectedRows.includes(row);
  }

  constructor(
    private layoutService: LayoutService,
    private drawerService: NzDrawerService
  ) {}

  ngOnInit(): void {
    //console.log(this.DocEntry);
    //console.log(this.DocType);

    this.isLoading = true;
    this.layoutService
      .getChangeLog(this.DocType, this.DocEntry)
      .subscribe((result: ADOCRecord[]) => {
        this.adocRows = result;
        this.adocRows.forEach((element) => {
          if (element.LogInstanc == 100000) {
            element.LogInstanc = this.adocRows.length;
          }
        });
        this.isLoading = false;
      });
  }

  onCheckboxChange(event: any, row: any) {
    if (event.target.checked) {
      // add to selected if not already there
      if (!this.selectedRows.includes(row)) {
        this.selectedRows.push(row);
      }
    } else {
      // remove from selected
      this.selectedRows = this.selectedRows.filter((r) => r !== row);
    }
  }

  processSelectedRows() {
    console.log('Selected Rows:', this.selectedRows);
    const drawerRef = this.drawerService.create({
      nzContent: CompareResultComponent,
      nzWrapClassName: 'drawer-size-4x',
      nzContentParams: {
        selectedRows: this.selectedRows,
        moduleId: this.moduleId,
        lastInstanceIndex: this.adocRows.length,
        adocRows: this.adocRows,
      },
      nzTitle: 'Differences',
    });
  }

  openLogRecord(logRecord: ADOCRecord) {
    RecordPageComponent.openRecordPage(this.drawerService, {
      actionType: 'View',
      drawerTitle: 'History Instance #' + logRecord.LogInstanc,
      inDrawer: true,
      moduleId: this.moduleId,
      recordId: this.DocEntry,
      parentComponent: this,
      recordModel: undefined,
      fromLog: true,
      logInstance: logRecord.LogInstanc,
    });
  }
}
